// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditBoardModal_modal__2sZNQ","modal_background":"EditBoardModal_modal_background__DhdXF","modal-content":"EditBoardModal_modal-content__1dd9B"};